import { render, staticRenderFns } from "./UnifiedLogin.vue?vue&type=template&id=5a7ec816&scoped=true"
import script from "./UnifiedLogin.vue?vue&type=script&lang=js"
export * from "./UnifiedLogin.vue?vue&type=script&lang=js"
import style0 from "./UnifiedLogin.vue?vue&type=style&index=0&id=5a7ec816&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7ec816",
  null
  
)

export default component.exports